import React from "react";
import "./contactMethodComponent.scss";

const ContactMethod = ({ icon: Icon, text, responsiveTextColor }) => {
  return (
    <div
      className="contact-method-container"
      style={{
        '--responsive-text-color': responsiveTextColor, 
      }}
    >
      {Icon && <Icon className="icon" />}
      {text}
    </div>
  );
};

export default ContactMethod;
